import { FC, SVGAttributes } from "react";

const ColorCheck: FC<SVGAttributes<SVGSVGElement>> = ({
  stroke = "#FFF",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <g stroke={stroke} strokeWidth="2">
          <path
            d="M1 7.077L5.949 12 15 3"
            transform="translate(-28 -366) translate(16 186) translate(0 168) translate(12 12)"
          />
        </g>
      </g>
    </svg>
  );
};

export { ColorCheck };
